import React, { useMemo } from "react";
import GradeSimpleDetail from "./GradeSimpleDetail";
import "../styles.css";
import { colors } from "theme";
import RenderGradeSummarySwitch from "./RenderGradeSummarySwitch";
import { Button, Divider, Stack } from "@mui/material";
import { order } from "../schema";
import { useNavigate } from "react-router";
import routes from "components/routes";
import http from "services/httpService";
import { Ptag } from "components/core";
import { CoverateNotesWrapper } from "./styles";

const GradeSummaryDetail = ({ gradeData, productIdName, state, isFlat, reusables }) => {
  const navigate = useNavigate();
  const sortedProducts = useMemo(() => {
    const normalizedOrder = order.map((item) => item.trim());

    // Map to normalize space and trim in input array for matching
    const mappedArr = productIdName?.map((subArr) => [
      subArr[0],
      subArr[1]?.trim(),
    ]);

    return mappedArr.sort((a, b) => {
      // Find the index of the elements in the order array
      const indexA = normalizedOrder.indexOf(a[1]);
      const indexB = normalizedOrder.indexOf(b[1]);

      return indexA - indexB;
    });
  }, [productIdName]);

  const deleteGrade = async () => {
    const payload = {
      userplan_id: gradeData?.userplan,
      plan_grade_mapping_id: gradeData?.plan_grade_mapping_id,
    };
    console.log(gradeData, payload);
    try {
      const resp = await http.post("/business/delete_grade/", payload);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  const redirectionToSetupflow = () => {
    localStorage.setItem("eb_current_plan", gradeData?.userplan);
    navigate(`/${routes.GRADE_SETUP}`, {
      state: {
        mappingId: gradeData?.plan_grade_mapping_id,
        postIssuance: state ? true : false,
      },
    });
  };

  const renderOtherDetails = () => {
    if (!gradeData?.other_details || gradeData?.other_details.length === 0)
      return null;
    const validNotes = gradeData?.other_details.filter((str) => str);
    if (validNotes.length === 0) return null;
    if (validNotes.length === 1) {
      return (
        <GradeSimpleDetail title="Coverage Notes">
          <Ptag fontSize="14px" marginTop="8px">
            {validNotes[0]}
          </Ptag>
        </GradeSimpleDetail>
      );
    }
    return (
      <GradeSimpleDetail title="Coverage Notes">
        <CoverateNotesWrapper>
          {gradeData?.other_details.map((grade, index) => (
            <li key={index} style={{
              marginBottom: "1rem"
            }}>
              <Ptag fontSize="14px">{grade}</Ptag>
            </li>
          ))}
        </CoverateNotesWrapper>
      </GradeSimpleDetail>
    );

    // {gradeData?.other_details && (
    //   <GradeSimpleDetail title="Coverage Notes">
    //     <CoverateNotesWrapper>
    //       {gradeData?.other_details.map((grade) => (
    //         <li>
    //           <Ptag fontSize="14px">{grade}</Ptag>
    //         </li>
    //       ))}
    //     </CoverateNotesWrapper>
    //   </GradeSimpleDetail>
    // )}
  };

  return (
    <section
      style={{
        padding: "0px 16px",
      }}
    >
      {!isFlat && (
        <Divider style={{ marginTop: "-20px", marginBottom: "30px" }} />
      )}
      {/* {gradeData?.grade_code && (
        <GradeSimpleDetail
          title="Grade Code"
          text={`${gradeData?.grade_code}`}
        />
      )} */}
      {sortedProducts &&
        sortedProducts.map(([id, name], index) => {
          const attributeDetails =
            gradeData?.grade_attributes_data &&
            gradeData.grade_attributes_data.find(
              (obj) => obj.attribute_product_mapping === id
            );
          return (
            <RenderGradeSummarySwitch
              name={name}
              attributeData={attributeDetails}
              grade={gradeData}
              key={index}
              reusables={reusables}
              id={id}
            />
          );
        })}
      {renderOtherDetails()}
      {/* {gradeData?.other_details && (
        <GradeSimpleDetail title="Coverage Notes">
          <CoverateNotesWrapper>
            {gradeData?.other_details.map((grade) => (
              <li>
                <Ptag fontSize="14px">{grade}</Ptag>
              </li>
            ))}
          </CoverateNotesWrapper>
        </GradeSimpleDetail>
      )} */}

      <footer
        style={{
          marginBottom: "1rem",
          marginTop: "5rem",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Stack direction="row" spacing={2}>
          {!state && (
            <Button
              variant="contained"
              style={buttonStyle}
              sx={{
                boxShadow: "none",
              }}
              onClick={() => deleteGrade(gradeData)}
            >
              Delete Grade
            </Button>
          )}
          <Button
            variant="contained"
            sx={{
              boxShadow: "none",
            }}
            style={buttonStyle1}
            onClick={() => redirectionToSetupflow()}
          >
            Edit Grade
          </Button>
        </Stack>
      </footer>
    </section>
  );
};

export default GradeSummaryDetail;

const buttonStyle1 = {
  fontSize: "14px",
  textTransform: "none",
  backgroundColor: `${colors.primaryColor}`,
  width: "14rem",
  // border: "1px solid",
};
const buttonStyle = {
  fontSize: "14px",
  textTransform: "none",
  color: `${colors.primaryColor}`,
  backgroundColor: "#F6F3FF",
  width: "14rem",
  border: "1px solid",
};
